import {
  useEffect,
  useRef,
  useState,
} from 'react';

import useLeafletMap from './useLeafletMap';

// Built from the first render's props; later changes go through the layer's own setters
const useLeafletLayer = (createLayer, eventHandlers) => {
  const map = useLeafletMap();
  const createRef = useRef(createLayer);
  const [layer, setLayer] = useState(null);

  useEffect(
    () => {
      if (!map) return undefined;
      const created = createRef.current().addTo(map);
      setLayer(created);
      return () => {
        created.remove();
      };
    },
    [map],
  );

  useEffect(
    () => {
      if ((!layer) || (!eventHandlers)) return undefined;
      layer.on(eventHandlers);
      return () => {
        layer.off(eventHandlers);
      };
    },
    [layer, eventHandlers],
  );

  return layer;
};

export default useLeafletLayer;
